import { ReactNode } from "react";
import styled from "styled-components";
import { theme } from "../../helpers/theme";

import { ReactComponent as Workers } from "../../../src/assets/icons/workers.svg";
import { ReactComponent as Frame } from "../../../src/assets/icons/frame.svg";

import Icon from "../icon";

interface LayoutAccountProps {
  children: ReactNode;
}

export const LayoutAccount = ({ children }: LayoutAccountProps) => {
  return (
    <LayoutContainerAccount>
      <Icon icon={<Workers />} displayNoneSize={`${theme.device.Mtablet}`} />
      <FormLayoutWrapper>{children}</FormLayoutWrapper>
      <Icon icon={<Frame />} displayNoneSize={`${theme.device.Mtablet}`} />
    </LayoutContainerAccount>
  );
};

const LayoutContainerAccount = styled.div`
  background-color: ${theme.colors.gray04_background};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 50px 0px;
`;

const FormLayoutWrapper = styled.div`
  width: 100%;
  padding: 0px 16px;
`;
